export default __webpack_public_path__ + "static/media/illustration_accept.b7806477.svg";